export default function (element, offset = 0) {
  const header = $('header').height();
  let position = element && element.length ? element.offset().top - header : 0;
  if (offset > 0) {
    position -= offset;
  }
  $('html, body').animate({
    scrollTop: position,
  }, 500);
  if (!element) {
    $('.logo-home').trigger('focus');
  } else {
    element.trigger('focus');
  }
}
